import { render, staticRenderFns } from "./MlocalidadFormHeader.vue?vue&type=template&id=32aeaf16"
import script from "./MlocalidadFormHeader.vue?vue&type=script&lang=js"
export * from "./MlocalidadFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports